// extracted by mini-css-extract-plugin
export default {"wrapper":"ModifiersFooter-module__wrapper___ghS5m","buttonWrapper":"ModifiersFooter-module__buttonWrapper___8NE41"};